// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-primary {
  background-color: var(--primary-button-color) !important;
  border-color: var(--primary-button-border-color) !important;
  /* z-index: 1 !important; */
}

body {
  background-color: #f4f4f4;
}

.btn-blue {
  background-color: #1c7cd5 !important;
  border-color: #1261ab !important;
}

.css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__drawer-left___2xURN-sass,
.css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__overlay___2QFmC-sass {
  z-index: 1;
  min-width: 270px;
  width: 40%;
}

.css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__drawer___2r5VH-sass {
  background-color: #fff !important;
}

.css-sourceMap-modules-importLoaders-1-localIdentName-animate__fadeInLeft___2Rcw5 {
  z-index: 11;
  overflow: auto;
}

.css-1hwfws3 {
  font-size: 12px;
}

.custom-control-input {
  z-index: 2 !important;
  margin: 4px;
  left: 0px;
  height: 1rem;
  width: 1rem;
}

.fontsize-12 {
  font-size: 12px !important;
}

.fontsize-14 {
  font-size: 14px !important;
}

.list-blank .list-blank-area {
  margin: auto;
  padding: 12px 0px;
}

.list-blank .list-blank-area p {
  font-family: HelveticaNeue;
  font-size: 10px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: rgba(93, 108, 119, 0.71);
}

.list-blank .list-blank-area p.header {
  font-size: 20px;
  font-weight: 500;
  color: black;
}

.list-blank .list-blank-area p.error-header {
  font-size: 16px;
  font-weight: 350;
  color: #606060;
}

.list-blank .list-blank-area p img {
  font-size: 20px;
  height: 180px;
  padding: 8px;
}

/* 50px is navbar height */
.modal-content {
  max-height: 98vh;
  overflow: auto;
}

.react-datepicker__navigation--previous:hover,
.react-datepicker__navigation--next:hover {
  outline: none !important;
}

.primary-gradient button {
  width: 118px;
  height: 28px;
  border-radius: 4px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
  background-image: linear-gradient(256deg, #4ad295, #30c072);
  float: right;
  font-family: HelveticaNeue;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.42;
  letter-spacing: normal;
  color: #ffffff;
  border: 0;
}

.reactstrap-datepicker {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.alert {
  position: inherit !important;
}

.react-datepicker__input-container {
  position: inherit !important;
}

.react-datepicker__close-icon {
  /* top: auto !important; */
  right: 12% !important;
  /* height: 16px !important;
	display: block !important;
	vertical-align: auto; */
}

.toast-notification {
  margin-top: 50px !important;
}
`, "",{"version":3,"sources":["webpack://./src/stylesheets/style.css"],"names":[],"mappings":"AAAA;EACE,wDAAwD;EACxD,2DAA2D;EAC3D,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,2DAA2D;EAC3D,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB;;wBAEsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".btn-primary {\n  background-color: var(--primary-button-color) !important;\n  border-color: var(--primary-button-border-color) !important;\n  /* z-index: 1 !important; */\n}\n\nbody {\n  background-color: #f4f4f4;\n}\n\n.btn-blue {\n  background-color: #1c7cd5 !important;\n  border-color: #1261ab !important;\n}\n\n.css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__drawer-left___2xURN-sass,\n.css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__overlay___2QFmC-sass {\n  z-index: 1;\n  min-width: 270px;\n  width: 40%;\n}\n\n.css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__drawer___2r5VH-sass {\n  background-color: #fff !important;\n}\n\n.css-sourceMap-modules-importLoaders-1-localIdentName-animate__fadeInLeft___2Rcw5 {\n  z-index: 11;\n  overflow: auto;\n}\n\n.css-1hwfws3 {\n  font-size: 12px;\n}\n\n.custom-control-input {\n  z-index: 2 !important;\n  margin: 4px;\n  left: 0px;\n  height: 1rem;\n  width: 1rem;\n}\n\n.fontsize-12 {\n  font-size: 12px !important;\n}\n\n.fontsize-14 {\n  font-size: 14px !important;\n}\n\n.list-blank .list-blank-area {\n  margin: auto;\n  padding: 12px 0px;\n}\n\n.list-blank .list-blank-area p {\n  font-family: HelveticaNeue;\n  font-size: 10px;\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: center;\n  color: rgba(93, 108, 119, 0.71);\n}\n\n.list-blank .list-blank-area p.header {\n  font-size: 20px;\n  font-weight: 500;\n  color: black;\n}\n\n.list-blank .list-blank-area p.error-header {\n  font-size: 16px;\n  font-weight: 350;\n  color: #606060;\n}\n\n.list-blank .list-blank-area p img {\n  font-size: 20px;\n  height: 180px;\n  padding: 8px;\n}\n\n/* 50px is navbar height */\n.modal-content {\n  max-height: 98vh;\n  overflow: auto;\n}\n\n.react-datepicker__navigation--previous:hover,\n.react-datepicker__navigation--next:hover {\n  outline: none !important;\n}\n\n.primary-gradient button {\n  width: 118px;\n  height: 28px;\n  border-radius: 4px;\n  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);\n  background-image: linear-gradient(256deg, #4ad295, #30c072);\n  float: right;\n  font-family: HelveticaNeue;\n  font-size: 12px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.42;\n  letter-spacing: normal;\n  color: #ffffff;\n  border: 0;\n}\n\n.reactstrap-datepicker {\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.alert {\n  position: inherit !important;\n}\n\n.react-datepicker__input-container {\n  position: inherit !important;\n}\n\n.react-datepicker__close-icon {\n  /* top: auto !important; */\n  right: 12% !important;\n  /* height: 16px !important;\n\tdisplay: block !important;\n\tvertical-align: auto; */\n}\n\n.toast-notification {\n  margin-top: 50px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
